const ar: Record<string, string> = {
  "Virtual Try-On": "تجربة افتراضية",
  "Find Your Size & See It On You": "اعثر على مقاسك وجرّبه",
  "See Your Fit": "شاهد الملاءمة",
  "Check your size, then try it on virtually": "تحقق من مقاسك ثم جرّبه افتراضياً",
  "Get Your Size": "مقاسك",
  "Instant fit suggestion": "اقتراح فوري للمقاس",
  "Try It On": "جرّبه",
  "See how it looks on you": "شاهد كيف يبدو عليك",
  "Find My Size": "اعثر على مقاسي",
  "Takes less than a minute": "يستغرق أقل من دقيقة",
  "Upload a full body photo": "ارفع صورة بالطول الكامل",
  "JPEG, PNG or WebP (max 10MB)": "JPEG أو PNG أو WebP (الحد الأقصى 10 ميجابايت)",
  "Your photo": "صورتك",
  "Let's find your best fit": "لنجد أفضل مقاس لك",
  "Centimeters": "سنتيمترات",
  "Inches": "بوصات",
  "Load saved profile...": "تحميل ملف محفوظ...",
  "HEIGHT": "الطول",
  "WEIGHT": "الوزن",
  "feet": "قدم",
  "inches": "بوصة",
  "cm": "سم",
  "kg": "كغ",
  "lbs": "رطل",
  "in": "بوصة",
  "How to measure": "كيفية القياس",
  "Hide guide": "إخفاء الدليل",
  "I know my measurements": "أعرف قياساتي",
  "Not sure? Use height & weight instead": "غير متأكد؟ استخدم الطول والوزن",
  "Please fill in height and weight": "يرجى إدخال الطول والوزن",
  "Please fill in all required fields": "يرجى ملء جميع الحقول المطلوبة",
  "Next": "التالي",
  "Analyzing your size...": "جارٍ تحليل مقاسك...",
  "SUGGESTED SIZE": "المقاس المقترح",
  "NOT SUGGESTED": "غير مقترح",
  "Edit measurements": "تعديل القياسات",
  "Size guide": "دليل المقاسات",
  "Your fit": "ملاءمتك",
  "Your Suggested Size": "المقاس المقترح",
  "Your measure": "قياسك",
  "within range": "ضمن النطاق",
  "too tight": "ضيق جداً",
  "tight": "ضيق",
  "a bit tight": "ضيق قليلاً",
  "too loose": "واسع جداً",
  "loose": "واسع",
  "a bit loose": "واسع قليلاً",
  "See fit on your photo": "شاهد الملاءمة على صورتك",
  "Hide visual fit": "إخفاء عرض الملاءمة",
  "Analyzing...": "جارٍ التحليل...",
  "Try it on": "جرّبه",
  "SIZE CHART": "جدول المقاسات",
  "YOUR ESTIMATED MEASUREMENTS": "قياساتك التقديرية",
  "Edit": "تعديل",
  "Download": "تحميل",
  "Size chart": "جدول المقاسات",
  "Preparing your image...": "جارٍ تحضير صورتك...",
  "Analyzing body proportions...": "جارٍ تحليل نسب الجسم...",
  "Matching garment to your photo...": "جارٍ مطابقة الملابس مع صورتك...",
  "Generating virtual try-on...": "جارٍ إنشاء التجربة الافتراضية...",
  "Refining details...": "جارٍ تحسين التفاصيل...",
  "Almost there...": "أوشكنا على الانتهاء...",
  "Complete!": "تم!",
  "This usually takes 15-25 seconds": "عادة ما يستغرق 15-25 ثانية",
  "Something went wrong": "حدث خطأ ما",
  "Try Again": "حاول مرة أخرى",
  "We couldn't find a matching size for you": "لم نتمكن من العثور على مقاس مناسب لك",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "يرجى تجربة شاشة القياسات اليدوية حتى نتمكن من حساب الملاءمة من قياساتك.",
  "Try manual measurements": "جرّب القياسات اليدوية",
  "SDK not configured. Please provide an API key.": "SDK غير مُهيأ. يرجى تقديم مفتاح API.",
  "Please upload a JPEG, PNG, or WebP image.": "يرجى رفع صورة بصيغة JPEG أو PNG أو WebP.",
  "Image must be under 10MB.": "يجب أن تكون الصورة أقل من 10 ميجابايت.",
  "Try-on generation failed": "فشل إنشاء التجربة",
  "Failed to start try-on": "فشل بدء التجربة",
  "No product image found. Please set the product-image attribute.": "لم يتم العثور على صورة المنتج. يرجى تعيين خاصية product-image.",
  "Powered by": "مدعوم من",
  "My Profiles": "ملفاتي الشخصية",
  "History": "السجل",
  "No saved profiles yet.": "لا توجد ملفات محفوظة بعد.",
  "No history yet.": "لا يوجد سجل بعد.",
  "Product": "المنتج",
  "Women's": "نسائي",
  "Men's": "رجالي",
  "Profiles": "الملفات الشخصية",
  "Women's Profile": "ملف نسائي",
  "Men's Profile": "ملف رجالي",
  "Height": "الطول",
  "Weight": "الوزن",
  "Chest": "الصدر",
  "Bust": "محيط الصدر",
  "Waist": "الخصر",
  "Hips": "الأرداف",
  "Shoulders": "الأكتاف",
  "Sleeve": "الكم",
  "Inseam": "طول الساق الداخلي",
  "Neck": "الرقبة",
  "Foot": "القدم",
  "Shoe EU": "حذاء EU",
  "Shoe US": "حذاء US",
  "Shoe UK": "حذاء UK",
  "Saved": "تم الحفظ",
  "Delete Profile": "حذف الملف الشخصي",
  "Shoe size (US)": "مقاس الحذاء (US)",
  "Shoe size (UK)": "مقاس الحذاء (UK)",
  "Shoe size (EU)": "مقاس الحذاء (EU)",
  "Generating...": "جارٍ الإنشاء...",
  "Foot length": "طول القدم",
  "Size": "المقاس",
  "Try on size": "تجربة المقاس",
  "e.g.": "مثال",
  "Drop your photo here or click to upload": "اسحب صورتك هنا أو انقر للتحميل",
  "This usually takes 15-20 seconds": "عادة ما يستغرق 15-20 ثانية",
  "Try-on result": "نتيجة التجربة",
  "Try Another": "جرّب صورة أخرى",
  "Back": "رجوع",
  "You": "أنت",
  "Garment": "الملابس",
  "Your Height": "طولك",
  "Your Weight": "وزنك",
  "Drag or scroll to set your height": "اسحب أو مرر لتعيين طولك",
  "Drag or scroll to set your weight": "اسحب أو مرر لتعيين وزنك",
  "Enter height and weight first": "أدخل الطول والوزن أولاً",

  // ── Field labels ──
  "Lens Width": "عرض العدسة",
  "Bridge": "الجسر",
  "Arm Length": "طول الذراع",
  "Head Circumference": "محيط الرأس",
  "Face Width": "عرض الوجه",
  "Temple": "الذراع",
  "Around widest point": "حول أعرض نقطة",
  "Foot Length": "طول القدم",
  "Shoulder": "الكتف",
  "Thigh": "الفخذ",
  "Hip": "الورك",

  // ── Units ──
  "Millimetre": "ملم",
  "Centimetre": "سم",
  "Millimeters": "ملم",

  // ── Fit descriptors ──
  "Tight": "ضيق",
  "Loose": "فضفاض",
  "Short": "قصير",
  "Long": "طويل",
  "✓ Fit": "✓ مناسب",
  "too short": "قصير جداً",
  "too long": "طويل جداً",
  "a bit short": "قصير قليلاً",
  "a bit long": "طويل قليلاً",

  // ── Length pills ──
  "Length": "الطول",
  "Length Adjustment": "ضبط الطول",
  "Regular": "عادي",
  "Big": "كبير",
  "Big & Tall": "كبير وطويل",

  // ── Misc ──
  "preview": "معاينة",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "حمّل صورتك",
  "Upload a photo": "تحميل صورة",
  "Click or drag a full-body photo": "انقر أو اسحب صورة كاملة للجسم",
  "Or upload a photo for AI sizing": "أو حمّل صورة لتحديد المقاس بالذكاء الاصطناعي",
  "Photo": "صورة",
  "How to take a good photo": "كيفية التقاط صورة جيدة",
  "How to take the best photo": "كيفية التقاط أفضل صورة",
  "Do": "افعل",
  "Don't": "لا تفعل",
  "Quick Tip": "نصيحة سريعة",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "كلما كانت صورتك أبسط، كانت نتائج التجربة الافتراضية أدق.",
  "Choose a plain background (a light wall is ideal)": "اختر خلفية بسيطة (الجدار الفاتح مثالي)",
  "Stand facing the camera with your full body in frame": "قف في مواجهة الكاميرا مع ظهور جسمك بالكامل",
  "Stand straight and still, arms relaxed by your sides": "قف بشكل مستقيم وثابت مع إرخاء الذراعين على الجانبين",
  "Stand with your HEELS against a wall for best accuracy": "قف وكعباك مستندان إلى الحائط للحصول على أفضل دقة",
  "Use natural or even lighting (e.g. near a window)": "استخدم إضاءة طبيعية أو متساوية (مثل بالقرب من نافذة)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "ارتد ملابس ضيقة وبسيطة (مثل ألوان محايدة)",
  "Don't wear loose, baggy, or layered clothing": "لا ترتد ملابس فضفاضة أو متعددة الطبقات",
  "Don't sit, pose, or bend your body": "لا تجلس أو تتخذ وضعية أو تنحني",
  "Don't use strong backlighting": "لا تستخدم إضاءة خلفية قوية",
  "Don't take mirror photos or selfies": "لا تلتقط صورًا في المرآة أو سيلفي",
  "Don't apply filters, effects, or edits": "لا تطبق فلاتر أو تأثيرات أو تعديلات",

  // ── Age gate ──
  "Are you 18 or older?": "هل عمرك 18 سنة أو أكبر؟",
  "Yes": "نعم",
  "No": "لا",
  "Please confirm your age": "يرجى تأكيد عمرك",
  "Please confirm that the person in the photo is 18 or older before uploading.": "يرجى تأكيد أن الشخص في الصورة عمره 18 سنة أو أكبر قبل التحميل.",
  "Under 18 — can't process this photo.": "أقل من 18 سنة — لا يمكن معالجة هذه الصورة.",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "تبدو هذه الصورة لقاصر. يرجى تحميل صورة لشخص عمره 18 سنة أو أكبر.",
  "Different photo needed": "نحتاج صورة مختلفة",
  "Try another photo": "جرّب صورة أخرى",

  // ── Photo step controls ──
  "Continue": "متابعة",
  "Analyze My Size": "تحليل مقاسي",
  "Analyzing photo…": "جاري تحليل الصورة…",
  "Details": "التفاصيل",
  "Image must be under 10MB": "يجب أن تكون الصورة أقل من 10 ميغابايت",
  "Please upload an image file": "يرجى تحميل ملف صورة",
  "Please upload a photo": "يرجى تحميل صورة",
  "Prefer not to upload a photo?": "تفضل عدم تحميل صورة؟",
  "Enter measurements manually": "إدخال القياسات يدويًا",
  "Legal Notice": "إشعار قانوني",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "سيتم استخدام صورتك لإنشاء معاينة للتجربة الافتراضية تُظهر كيف يمكن أن تبدو العناصر المختارة وتناسبك. تتم معالجة الصور بأمان ولا يتم تخزينها بعد التوليد.",

  // ── BodyProfileView — form (right section) ──
  "Body details": "تفاصيل الجسم",
  "Your body details": "تفاصيل جسمك",
  "Body Measurements": "قياسات الجسم",
  "AGE": "العمر",
  "years": "سنة",
  "Enter your height": "أدخل طولك",
  "Enter your weight": "أدخل وزنك",
  "Enter your bra size": "أدخل مقاس حمالة الصدر",
  "Please enter your height": "يرجى إدخال طولك",
  "Please enter your weight": "يرجى إدخال وزنك",
  "Please enter a valid height": "يرجى إدخال طول صحيح",
  "Please enter a valid weight": "يرجى إدخال وزن صحيح",
  "Please enter a valid height (100-250 cm)": "يرجى إدخال طول صحيح (100-250 سم)",
  "Please enter a valid weight (30-300 kg)": "يرجى إدخال وزن صحيح (30-300 كغ)",
  "Please select both band and cup size": "يرجى اختيار مقاس الحزام والكأس",
  "Select your bra size": "اختر مقاس حمالة الصدر",
  "BAND": "الحزام",
  "BAND SIZE": "مقاس الحزام",
  "CUP": "الكأس",
  "CUP SIZE": "مقاس الكأس",
  "BRA REGION": "منطقة حمالة الصدر",
  "Imperial": "إمبراطوري",
  "Metric": "متري",
  "These calibrate the AI — all required.": "هذه تعاير الذكاء الاصطناعي — جميعها مطلوبة.",
  "Using": "تستخدم",
  "start fresh": "ابدأ من جديد",
  "Close": "إغلاق",

  // ── Body shape questions ──
  "Which best describes your chest?": "أيهما يصف صدرك بشكل أفضل؟",
  "WHICH BEST DESCRIBES YOUR CHEST?": "أيهما يصف صدرك بشكل أفضل؟",
  "Which best describes your hips?": "أيهما يصف وركيك بشكل أفضل؟",
  "WHICH BEST DESCRIBES YOUR HIPS?": "أيهما يصف وركيك بشكل أفضل؟",
  "Which best describes your midsection?": "أيهما يصف منطقة وسطك بشكل أفضل؟",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "أيهما يصف منطقة وسطك بشكل أفضل؟",
  "Which best describes your seat?": "أيهما يصف مؤخرتك بشكل أفضل؟",
  "WHICH BEST DESCRIBES YOUR SEAT?": "أيهما يصف مؤخرتك بشكل أفضل؟",
  "Average": "متوسط",
  "Narrow": "ضيق",
  "Broad": "عريض",
  "Curvy": "ممشوق",
  "A slimmer, narrower chest build": "بنية صدر أنحف وأضيق",
  "A moderate, proportionate chest": "صدر معتدل ومتناسب",
  "A wider, more muscular chest": "صدر أعرض وأكثر عضلية",
  "A flatter midsection with minimal protrusion": "منطقة وسط أكثر استواءً مع بروز قليل",
  "A moderate, natural midsection shape": "منطقة وسط معتدلة وطبيعية",
  "A fuller, more rounded midsection": "منطقة وسط أكثر امتلاءً واستدارة",
  "A flatter backside with less projection": "مؤخرة أكثر استواءً مع بروز أقل",
  "A moderate, natural backside shape": "مؤخرة معتدلة وطبيعية",
  "A fuller, more rounded backside": "مؤخرة أكثر امتلاءً واستدارة",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "تم التحميل من الملف الشخصي",
  "Clear": "مسح",
};
export default ar;
